import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  @Input() count: number = 0;
  @Input() disabled: boolean = false;
  @Input() ariaLabel: string = 'Notifications';

  @Output() click = new EventEmitter<void>();

  onButtonClick(): void {
    if (!this.disabled) {
      this.click.emit();
    }
  }

  get hasBadge(): boolean {
    return this.count > 0;
  }

  get displayCount(): string {
    if (this.count > 99) {
      return '99+';
    }
    return this.count.toString();
  }
}
